/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ReaderFragment } from 'relay-runtime';
import type { FragmentReference } from "relay-runtime";
declare export opaque type CartCustomHold_item$ref: FragmentReference;
export type CartCustomHold_item = {|
  +holds: ?$ReadOnlyArray<?{|
    +expirationDate: ?string
  |}>,
  +$refType: CartCustomHold_item$ref,
|};
*/


const node/*: ReaderFragment*/ = {
  "kind": "Fragment",
  "name": "CartCustomHold_item",
  "type": "Item",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "holds",
      "storageKey": null,
      "args": null,
      "concreteType": "Hold",
      "plural": true,
      "selections": [
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "expirationDate",
          "args": null,
          "storageKey": null
        }
      ]
    }
  ]
};
// prettier-ignore
(node/*: any*/).hash = 'ccd12f1794d78b73ae758abc606369f0';
module.exports = node;
